import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { ScheduledEvent } from '../../models/scheduled-events/scheduled-event.model';
import { ScheduledFolderEvent } from '../../models/scheduled-events/scheduled-folder-event.model';
import { ScheduledFormInstanceEvent } from '../../models/scheduled-events/scheduled-form-instance-event.model';
import { ScheduledEventService } from '../../services/scheduled-event.service';//'../../services/scheduled-event.service';
//import { ScheduledEventDirectToSchedulerService } from '../../services/scheduled-event-direct-to-scheduler.service';
import { Folder } from '../../models/site-content/folder.model';
import { IHasIdAndName } from '../../interfaces/has-id-and-name.interface';
import { ScheduledAction } from '../../models/scheduled-events/scheduled-event.enums';

// Constants.
const FOLDER_STRUCTURE_NAME: string = 'Folder';
const FORM_INSTANCE_STRUCTURE_NAME: string = 'Form';

@Component({
    selector: 'app-scheduled-events-dialog',
    templateUrl: './scheduled-events.dialog.html',
    styleUrls: ['./scheduled-events.dialog.scss'],
    standalone: false
})
export class ScheduledEventsDialog implements OnInit {
    // Properties.
    private structureTypeName: string = null;

    // Constructor.
    public constructor(public dialogRef: MatDialogRef<ScheduledEventsDialog>,
        @Inject(MAT_DIALOG_DATA) public folderOrFormInstance: IHasIdAndName,
        private scheduledEventService: ScheduledEventService)
        //private scheduledEventDirectToSchedulerService: ScheduledEventDirectToSchedulerService)
    {
        return;
    }

    // Life cycle methods.
    public ngOnInit(): void {
        // Get my structure type.
        this.structureTypeName = (this.folderOrFormInstance.typeName() == Folder.TypeName ? FOLDER_STRUCTURE_NAME : FORM_INSTANCE_STRUCTURE_NAME);
    }

    // Accessor methods.
    public get StructureTypeName(): string {
        return this.structureTypeName;
    }

    public get SaveDisabled(): boolean {
        // Note:  this logic is not yet implemented.
        return false;
    }

    // Handle control events.
    public save(): void {
        this.createScheduledEvent();
    }

    public cancel(): void {
        this.dialogRef.close(null);
    }

    // Helper methods.
    private createScheduledEvent(): void {
        let scheduledEvent: ScheduledEvent = null;

        if (this.structureTypeName == FOLDER_STRUCTURE_NAME) {
            let scheduledFolderEvent: ScheduledFolderEvent = new ScheduledFolderEvent(ScheduledAction.SetWorkflowState);
            scheduledFolderEvent.folderId = this.folderOrFormInstance.getId();

            scheduledEvent = scheduledFolderEvent;
        } else {
            let scheduledFormInstanceEvent: ScheduledFormInstanceEvent = new ScheduledFormInstanceEvent(ScheduledAction.SetWorkflowState);
            scheduledFormInstanceEvent.formInstanceId = this.folderOrFormInstance.getId();

            scheduledEvent = scheduledFormInstanceEvent;
        }
        scheduledEvent.nextActionDate = new Date();
        scheduledEvent.eventText = "TBD";

        // Note:  events are now being scheduled from server code, not client code.
        /*
        this.scheduledEventService.createScheduledEvent(scheduledEvent).then(result => {
            console.log('Received a response.');
        });
        */
    }

}
